var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuyMedicine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 254,
    height: 200,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8F0FE",
    d: "M61.256 37.422c2.408-.583 4.82-1.147 7.18-1.806 9.052-2.521 16.891-7.175 23.38-14.024 7.786-8.222 16.649-17.25 27.943-20.265 11.061-2.953 23.104-.417 32.507 5.967 8.251 5.606 13.611 14.483 18.222 23.118 5.119 9.583 12.944 16.91 21.692 23.152 16.564 11.815 36.977 19.569 39.067 42.8 1.464 16.295-9.754 28.887-24.469 34.304-12.237 4.503-25.474 6.327-38.299 8.427-13.517 2.213-27.171 3.82-40.886 3.801-35.332-.048-76.403-13.114-91.953-47.81-7.199-16.039-8.194-39.991 8.09-51.01 5.27-3.569 11.394-5.17 17.526-6.654M127 194.62c57.645 0 104.375-3.93 104.375-8.777 0-4.848-46.73-8.778-104.375-8.778-57.644 0-104.374 3.93-104.374 8.778 0 4.847 46.73 8.777 104.374 8.777"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A004D",
    d: "M177.65 183.833H92.669a4.975 4.975 0 0 1-4.977-4.976V27.625a4.976 4.976 0 0 1 4.977-4.977h84.985a4.976 4.976 0 0 1 4.977 4.977v151.227a4.983 4.983 0 0 1-4.981 4.981"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M179.313 29.79v146.897a3.266 3.266 0 0 1-3.266 3.265H94.27a3.27 3.27 0 0 1-3.275-3.265V29.791a3.27 3.27 0 0 1 3.275-3.266h21.109a2.553 2.553 0 0 1 2.555 2.555c0 .706.284 1.341.744 1.8.459.47 1.094.754 1.801.754h29.36a2.55 2.55 0 0 0 2.545-2.554c0-.706.284-1.341.753-1.806a2.54 2.54 0 0 1 1.801-.744h21.119a3.253 3.253 0 0 1 3.256 3.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M140.73 28.331h-16.062a.53.53 0 1 1 0-1.061h16.062a.53.53 0 1 1 0 1.061M145.01 28.478a.64.64 0 1 0 0-1.28.64.64 0 0 0 0 1.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8F0FE",
    d: "M125.72 108.829h-24.882a2.143 2.143 0 0 1-2.142-2.142V81.805c0-1.18.958-2.142 2.142-2.142h24.882c1.18 0 2.142.957 2.142 2.142v24.882a2.143 2.143 0 0 1-2.142 2.142"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#516CDD",
    d: "M118.659 103.436h-10.024a1.526 1.526 0 0 1-1.526-1.526V88.488c0-.844.683-1.526 1.526-1.526h10.024c.844 0 1.526.682 1.526 1.526v13.422c0 .843-.687 1.526-1.526 1.526"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M116.36 84.161h-5.426a.873.873 0 0 0-.872.872v1.934h7.165v-1.934a.87.87 0 0 0-.867-.872"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8F0FE",
    d: "M111.426 86.517a.116.116 0 0 1-.114-.114v-1.44c0-.062.053-.114.114-.114s.114.052.114.113v1.441a.115.115 0 0 1-.114.114M110.801 86.517a.115.115 0 0 1-.113-.114v-1.44c0-.062.052-.114.113-.114s.114.052.114.113v1.441c.005.062-.047.114-.114.114M112.047 86.517a.115.115 0 0 1-.113-.114v-1.44c0-.062.052-.114.113-.114s.114.052.114.113v1.441c.005.062-.047.114-.114.114M112.672 86.517a.115.115 0 0 1-.113-.114v-1.44c0-.062.052-.114.113-.114s.114.052.114.113v1.441a.115.115 0 0 1-.114.114M113.293 86.517a.115.115 0 0 1-.113-.114v-1.44c0-.062.052-.114.113-.114s.114.052.114.113v1.441c.005.062-.047.114-.114.114M113.919 86.517a.115.115 0 0 1-.113-.114v-1.44c0-.062.052-.114.113-.114s.114.052.114.113v1.441a.115.115 0 0 1-.114.114M114.541 86.517a.115.115 0 0 1-.114-.114v-1.44c0-.062.052-.114.114-.114.061 0 .113.052.113.113v1.441c.005.062-.047.114-.113.114M115.166 86.517a.115.115 0 0 1-.113-.114v-1.44c0-.062.052-.114.113-.114s.114.052.114.113v1.441a.115.115 0 0 1-.114.114M115.787 86.517a.115.115 0 0 1-.114-.114v-1.44c0-.062.052-.114.114-.114.061 0 .113.052.113.113v1.441c.005.062-.047.114-.113.114M116.413 86.517a.115.115 0 0 1-.114-.114v-1.44c0-.062.052-.114.114-.114.061 0 .113.052.113.113v1.441a.11.11 0 0 1-.113.114"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#516CDD",
    d: "M117.712 93.705h-8.133v6.071h8.133zM117.711 91.27h-8.133v1.127h8.133z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M114.365 94.9h-1.441v3.692h1.441z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M115.491 97.463v-1.44h-3.692v1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8F0FE",
    d: "M125.721 144.322h-24.882a2.143 2.143 0 0 1-2.142-2.142v-24.882c0-1.18.958-2.142 2.142-2.142h24.882c1.18 0 2.142.958 2.142 2.142v24.882c0 1.18-.962 2.142-2.142 2.142"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7D8F9",
    d: "m115.128 140.853-11.289-4.104a.75.75 0 0 1-.446-.953l5.943-16.336a.75.75 0 0 1 .953-.446l11.289 4.104a.75.75 0 0 1 .445.953l-5.943 16.337a.75.75 0 0 1-.952.445"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m113.398 123.925-2.54-.925a.65.65 0 1 1 .445-1.222l2.541.924a.65.65 0 0 1-.446 1.223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#516CDD",
    d: "m112.147 123.47-1.294-.47a.65.65 0 1 1 .445-1.222l1.294.469z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m112.28 126.995-2.54-.924a.65.65 0 1 1 .445-1.223l2.54.924a.65.65 0 1 1-.445 1.223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#516CDD",
    d: "m111.029 126.54-1.294-.469a.65.65 0 1 1 .445-1.223l1.294.469z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m111.167 130.061-2.541-.924a.65.65 0 0 1 .446-1.223l2.54.925a.65.65 0 1 1-.445 1.222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#516CDD",
    d: "m109.915 129.606-1.294-.469a.65.65 0 0 1 .446-1.223l1.294.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m110.047 133.128-2.54-.924a.65.65 0 1 1 .446-1.223l2.54.924a.65.65 0 1 1-.446 1.223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#516CDD",
    d: "m108.801 132.673-1.294-.469a.65.65 0 1 1 .446-1.223l1.294.469z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m108.934 136.193-2.54-.924a.65.65 0 1 1 .445-1.223l2.541.924a.65.65 0 1 1-.446 1.223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#516CDD",
    d: "m107.682 135.738-1.294-.469a.65.65 0 1 1 .446-1.223l1.293.469z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m118.579 125.81-2.541-.924a.65.65 0 0 1 .446-1.223l2.54.925a.65.65 0 1 1-.445 1.222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#516CDD",
    d: "m117.327 125.355-1.293-.469a.65.65 0 1 1 .445-1.223l1.294.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m117.464 128.878-2.54-.924a.65.65 0 1 1 .446-1.223l2.54.924a.65.65 0 1 1-.446 1.223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#516CDD",
    d: "m116.214 128.423-1.294-.469a.65.65 0 1 1 .446-1.223l1.294.469z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m116.347 131.947-2.54-.924a.65.65 0 1 1 .445-1.223l2.541.924a.65.65 0 1 1-.446 1.223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#516CDD",
    d: "m115.096 131.492-1.294-.469a.65.65 0 1 1 .446-1.223l1.293.469z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m115.233 135.014-2.54-.924a.65.65 0 1 1 .445-1.222l2.54.924a.65.65 0 1 1-.445 1.222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#516CDD",
    d: "m113.982 134.56-1.294-.47a.65.65 0 1 1 .445-1.222l1.294.469z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m114.115 138.082-2.54-.924a.65.65 0 1 1 .445-1.223l2.54.924a.65.65 0 1 1-.445 1.223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#516CDD",
    d: "m112.868 137.627-1.293-.469a.65.65 0 1 1 .445-1.223l1.294.469zM171.517 82.53h-36.36v1.63h36.36zM171.517 89.592h-36.36v1.63h36.36zM158.001 96.653h-22.844v1.63h22.844zM171.516 122.055h-36.36v1.63h36.36zM171.516 129.116h-36.36v1.631h36.36zM158 136.173h-22.844v1.63H158z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A004D",
    d: "m188.337 25.208 4.744 7.337h-16.55l-5.014-10.854h10.36a7.7 7.7 0 0 1 6.46 3.517"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#516CDD",
    d: "m171.517 21.691 5.014 10.854h-16.545l-3.009-10.854z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A004D",
    d: "m156.977 21.691 3.009 10.854h-16.554l-1.005-10.854z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#516CDD",
    d: "m142.427 21.691 1.005 10.854h-16.55l1.005-10.854z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A004D",
    d: "m127.887 21.691-1.005 10.854h-16.545l3.005-10.854z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#516CDD",
    d: "m113.341 21.691-3.004 10.854H93.782l5.02-10.854z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A004D",
    d: "m98.801 21.691-5.014 10.854h-16.55l4.74-7.337a7.7 7.7 0 0 1 6.464-3.517z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#260F60",
    d: "M77.232 32.545h16.555v1.81a8.277 8.277 0 0 1-8.275 8.275 8.277 8.277 0 0 1-8.275-8.275v-1.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B8AED",
    d: "M93.782 32.545h16.555v1.81a8.277 8.277 0 0 1-8.275 8.275 8.277 8.277 0 0 1-8.275-8.275v-1.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#260F60",
    d: "M110.332 32.545h16.555v1.81a8.277 8.277 0 0 1-8.275 8.275 8.277 8.277 0 0 1-8.275-8.275v-1.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B8AED",
    d: "M126.882 32.545h16.554v1.81a8.277 8.277 0 0 1-8.275 8.275 8.276 8.276 0 0 1-8.274-8.275v-1.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#260F60",
    d: "M143.432 32.545h16.554v1.81a8.277 8.277 0 0 1-8.275 8.275 8.277 8.277 0 0 1-8.275-8.275v-1.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B8AED",
    d: "M159.981 32.545h16.555v1.81a8.277 8.277 0 0 1-8.275 8.275 8.277 8.277 0 0 1-8.275-8.275v-1.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#260F60",
    d: "M176.536 32.545h16.555v1.81a8.277 8.277 0 0 1-8.275 8.275 8.277 8.277 0 0 1-8.275-8.275v-1.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#516CDD",
    d: "M165.488 66.123h-61.976a4.716 4.716 0 1 1 0-9.432h61.971a4.716 4.716 0 0 1 4.716 4.716 4.71 4.71 0 0 1-4.711 4.716"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.323,
    d: "M165.606 63.099a2.195 2.195 0 1 0 0-4.39 2.195 2.195 0 0 0 0 4.39ZM164.056 62.455l-1.645 1.645"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB5353",
    d: "M152.597 175.018H117.72a1.28 1.28 0 0 1-1.28-1.279v-13.123c0-.707.574-1.28 1.28-1.28h34.877a1.28 1.28 0 0 1 1.279 1.28v13.123a1.28 1.28 0 0 1-1.279 1.279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M130.737 167.576q.513.11.824.513.312.396.312.909 0 .741-.522 1.178-.513.429-1.439.429h-2.752v-5.907h2.659q.901 0 1.406.413.513.412.513 1.119 0 .522-.278.867-.268.345-.723.479m-2.138-.488h.943q.353 0 .538-.151.194-.16.194-.463t-.194-.463q-.185-.16-.538-.16h-.943zm1.061 2.356q.361 0 .555-.16.202-.168.202-.479a.6.6 0 0 0-.21-.488q-.203-.177-.564-.177h-1.044v1.304zm4.461-4.746v3.535q0 .53.261.816t.765.286q.505 0 .775-.286.269-.287.269-.816v-3.535h1.439v3.526q0 .79-.337 1.338-.336.548-.909.825a2.8 2.8 0 0 1-1.262.277q-.698 0-1.254-.269a2.08 2.08 0 0 1-.866-.825q-.32-.555-.32-1.346v-3.526zm9.585 0-2.045 3.955v1.952h-1.439v-1.952l-2.045-3.955h1.633l1.144 2.474 1.136-2.474z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA9A81",
    d: "M63.778 128.668s-3.256 13.948-3.55 15.213c-.517 2.251-2.375 7.455-2.375 7.455s7.882 4.431 10.133 3.043c1.697-1.048 1.583-6.944 1.735-9.128.142-2.086 6.023-22.143 6.023-22.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB5353",
    d: "M76.19 113.364s-7.527-3.451-10.868 6.602c-2.725 8.203-4.498 17.388-4.498 17.388l12.943 3.867z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA9A81",
    d: "M70.175 119.624c.014-.071 7.218 5.256 10.943 3.256 4.156-2.247 4.517-11.607 4.517-11.607l-2.328-8.91-.033-.147-.113-.535-.816.474-3.241 1.886-1.299.763-3.322 1.934s.355 2.346.26 4.322c-.014.208-.018.403-.042.592-.043.327-.138.65-.256.929-.27.664-.678 1.133-.678 1.138-.554 2.037-3.564 5.9-3.592 5.905"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E6E7",
    d: "M74.44 112.581c7.967.578 8.887-8.957 8.868-10.213l-.033-.147-.114-.535-.815.473c-.844.811-2.076 1.797-3.242 1.887l-1.299.763-3.322 1.933s.355 2.346.26 4.323c-.013.208-.018.403-.042.592a3.7 3.7 0 0 1-.26.924"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA9A81",
    d: "M69.194 102.075c1.308 4.521 3.413 9.005 7.81 8.061 3.077-.658 5.82-5.132 6.261-9.118.228-2.057.446-3.853.36-5.19a27 27 0 0 0-.156-1.72l-.895-2.256-.526-1.322s-1.043-.749-2.21-1.593c-1.459-1.056-3.501.711-3.544.636-.062-.119-6.346-.626-8.166 1.985-.01.005-.01.014-.01.014-.165.237-.288.48-.364.716a1.7 1.7 0 0 0-.076.597c.023.384.07.962.137 1.688.033.303.067.635.11.985.07.593.156 1.242.265 1.924.227 1.441.55 3.029 1.004 4.593"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A004D",
    d: "M83.834 95.77s2.01-10.79-6.63-10.042c0 0-6.759-2.559-10.83 1.157-3.62 3.303-1.611 7.327 1.313 8.019 1.915.45 10.256-2.735 11.63-2.038 1.375.701 3.91 8.715 3.91 8.715s-.023-3.715.607-5.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A004D",
    d: "M75.771 89.878c1.904-.255 3.233-2.068 2.969-4.05s-2.023-3.383-3.928-3.128-3.233 2.067-2.968 4.05c.264 1.981 2.023 3.382 3.927 3.128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A004D",
    d: "M70.795 92.64c2.475-.33 4.203-2.684 3.859-5.258s-2.629-4.392-5.104-4.062-4.203 2.685-3.86 5.259 2.63 4.392 5.105 4.062"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A004D",
    d: "M66.13 94.664c1.905-.255 3.234-2.068 2.97-4.05-.266-1.982-2.024-3.383-3.928-3.128-1.905.254-3.234 2.067-2.969 4.05.265 1.981 2.023 3.382 3.927 3.128M77.88 94.696c1.377-.184 2.339-1.496 2.147-2.93-.191-1.435-1.463-2.45-2.841-2.265-1.378.184-2.34 1.496-2.148 2.93.192 1.436 1.464 2.45 2.842 2.265M81.137 90.09c1.377-.184 2.339-1.496 2.147-2.931s-1.464-2.449-2.841-2.265-2.34 1.497-2.148 2.931c.192 1.435 1.464 2.449 2.842 2.265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A004D",
    d: "M82.596 93.195c1.377-.184 2.339-1.497 2.147-2.931-.192-1.435-1.464-2.45-2.841-2.265-1.378.184-2.34 1.496-2.148 2.93.192 1.436 1.464 2.45 2.841 2.266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A004D",
    d: "M82.723 95.762c1.167-.156 1.982-1.266 1.82-2.48-.162-1.215-1.24-2.073-2.408-1.917s-1.982 1.267-1.82 2.481 1.24 2.072 2.408 1.916M73.116 96.293c1.378-.184 2.34-1.496 2.148-2.93-.192-1.436-1.464-2.45-2.842-2.266-1.377.184-2.339 1.497-2.147 2.932.191 1.434 1.463 2.448 2.841 2.264M78.319 87.725c1.37-.183 2.326-1.488 2.135-2.915-.19-1.427-1.455-2.436-2.825-2.253s-2.326 1.488-2.136 2.915c.191 1.427 1.456 2.436 2.826 2.253"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA9A81",
    d: "M82.432 96.786s2.526-2.043 2.715.692c.19 2.734-2.275 4.184-2.275 4.184z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDAA98",
    d: "M83.185 97.592s2.056-.858.213 2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A004D",
    d: "M71.907 101.934c.228-.079.302-.458.166-.846s-.43-.638-.658-.558c-.227.079-.301.458-.165.846s.43.638.657.558M76.913 100.816c.228-.08.302-.459.166-.846-.136-.388-.43-.638-.658-.558-.227.08-.301.458-.165.846s.43.638.657.558M72.204 99.131s-1.36-.777-2.36-.08zM77.928 97.421c-.104 0-1.73-.08-2.559 1.062z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EDAA98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.141,
    d: "M74.218 101.534s.441 1.166-.042 1.578c-.484.413-.56 1.664.839 1.038"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M73.668 106.634s.076.109.232.237c.275.242.806.555 1.569.417.754-.137 1.204-.654 1.431-1.005.123-.199.18-.345.18-.345"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB5353",
    d: "M66.625 121.132c.555 7.91 2.029 15.569 2.616 23.351.967 8.322 1.55 15.801 1.56 15.877-.038-.242 3.213 1.943 10.895 3.199 7.313 1.194 19.526 2.303 22.759.801.113-.048-1.09-19.394-1.19-19.863-2.976-28.754-2.701-30.796-6.516-32.687-1.792-1.062-3.133-.991-5.204-1.37v-.005c-1.431-.298-5.507-.706-6.313-.715-1.943 2.848-5.588 7.758-8.483 8.308-1.446-.247-1.72-5.545-2.048-6.379-5.014 1.147-8.772 4.028-8.076 9.483"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA9A81",
    d: "M105.901 136.696s2.445 13.697.943 16.948c-1.318 2.849-2.071 5.417-18.38-1.948-4.208-1.9-13.653-8.568-13.653-8.568l3.374-4.882 16.431 5.232-.673-4.038z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#313131",
    strokeMiterlimit: 10,
    strokeWidth: 0.126,
    d: "m94.616 143.482 5.346 1.835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB5353",
    d: "M96.199 111.468s5.782 2.114 7.019 7.279c1.237 5.166 3.601 19.048 3.601 19.048l-13.052 2.038s-2.611-12.583-3.25-19.166c-.64-6.583 5.682-9.199 5.682-9.199"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#313131",
    strokeMiterlimit: 10,
    strokeWidth: 0.126,
    d: "M94.076 140.548s-2.924-13.298-3.564-19.886M66.952 123.763c.427 3.839 1.19 8.27 1.777 16.052"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#260F60",
    d: "m55.336 129.696.28-.531 9.838-.199 9.053 12.564-9.944.99-8.44-12.597z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A004D",
    d: "m65.175 129.502 9.052 12.559-9.943.991-8.948-13.356z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#260F60",
    d: "M58.596 132.152c.245-.165.243-.599-.005-.968s-.648-.535-.894-.37c-.245.165-.243.598.005.967.248.37.648.535.894.371"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA9A81",
    d: "M56.521 142.692s.066-2.753.028-4.057c-.038-1.308-.303-2.706.029-3.455s2.611-4.801 3.65-4.17c1.037.635-.93 2.493-1.361 3.753s-.308 1.46-.308 1.46 1.948-1.645 3.237-2.73c1.289-1.08 2.839-2.057 3.275-1.531s-2.185 2.877-2.673 3.365c0 0 3.151-3.042 3.687-2.625s-1.29 2.421-1.29 2.421.707-.346.105.65c-.607.995-1.028 3.26-1.483 4.071-.46.81-1.313 3.393-1.2 3.905z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.118,
    d: "m62.398 135.327-1.996 2.01M64.801 135.124l-2.896 3.095"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA9A81",
    d: "M56.592 141.896s-.673 11.654 4.521 13.36c5.195 1.706 6.877-.972 6.877-.972l-5.71-10.578"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeMiterlimit: 10,
    strokeWidth: 0.128,
    d: "m65.284 151.028-3.005-7.322"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA9A81",
    d: "M64.872 138.687s-1.255-.147-.625.891c.625 1.038 3.327 3.232 4.73 3.426 1.398.195 5.284-.213 5.838.119.55.336 3.45-4.683 3.45-4.683s-3.549-3.455-5.312-4.417c-.962-.526-2.697-.597-3.99-.393l1.208 1.796c.341.024.592.062.663.142.261.308-.165.602-1.113.408-.939-.194-5.759-2.1-6.076-1.597-.536.843 2.341 2.123 4.318 2.971.748.318 2.07 1.086 2.07 1.086s-1.208 0-2.46-.555c-1.255-.554-3.52-1.711-4.075-1.085-.56.64 1.374 1.891 1.374 1.891"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeMiterlimit: 10,
    strokeWidth: 0.128,
    d: "M64.872 138.687s2.484 1.952 4.706 2.075"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A004D",
    d: "M90.583 161.577s-31.526-9.118-38.56-9.379c-7.033-.26-12.767 3.474-8.16 11.289 4.601 7.816 28.217 19.351 28.217 19.351l6.692-4.848-5.99-6.427z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA9A81",
    d: "m84.208 180.027-7.284-5.408-4.844 7.934 7.493 5.758 3.9-.104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB5353",
    d: "M88.483 181.701s3.223 1.749 3.237 2.256c.038 1.408-.389 2.128-.573 3.692-.176 1.498-.351 2.739-1.493 4.972-.763 1.492-2.93 6.028-4.332 5.35-.119-.057-1.37-.379-1.398-.606-.28-2.56 4.559-15.664 4.559-15.664"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A004D",
    d: "M84.16 197.516c1.84-.606 8.347-11.654 5.541-14.763-1.56-1.739-5.791-3.341-5.791-3.341s-.891 3.199-3.441 7.261c-.82 1.303-1.479 1.104-1.488 1.251-.029.535.507 2.095.564 2.294.118.455 2.772 7.886 4.616 7.298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80.54 191.555a.34.34 0 0 0 .478.014l2.735-2.583a.338.338 0 1 0-.464-.493l-2.735 2.583a.34.34 0 0 0-.014.479M81.108 192.786a.34.34 0 0 0 .479.014l2.734-2.583a.337.337 0 0 0 .015-.478.337.337 0 0 0-.479-.015l-2.735 2.583a.34.34 0 0 0-.014.479M81.759 194.137a.34.34 0 0 0 .478.014l2.735-2.583a.338.338 0 1 0-.465-.493l-2.734 2.583a.34.34 0 0 0-.014.479M80 190.392a.337.337 0 0 0 .478.015l2.735-2.583a.338.338 0 1 0-.464-.493l-2.735 2.583a.337.337 0 0 0-.014.478"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.251,
    d: "m72.781 171.563-16.327-15.806"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA9A81",
    d: "m51.815 182.009 7.61-4.944 4.337 8.223-7.834 5.28-3.89-.351z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB5353",
    d: "M47.445 183.412s-3.327 1.545-3.37 2.048c-.123 1.402.256 2.151.341 3.72.081 1.507.18 2.753 1.18 5.057.669 1.535 2.546 6.199 3.991 5.611.118-.047 1.393-.294 1.431-.521.436-2.531-3.573-15.915-3.573-15.915"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A004D",
    d: "M50.773 199.463c-1.797-.72-6.981-11.63-4.607-15.08.867-1.261 5.436-2.711 5.986-2.972 0 0 .692 3.247 2.98 7.465.735 1.355 1.408 1.194 1.408 1.341-.004.535-.64 2.061-.706 2.256-.142.441-3.26 7.696-5.061 6.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.758 193.743a.34.34 0 0 1-.478-.015l-2.569-2.748a.34.34 0 0 1 .014-.479.343.343 0 0 1 .479.014l2.569 2.749a.34.34 0 0 1-.015.479M54.114 194.934a.34.34 0 0 1-.479-.014l-2.569-2.749a.34.34 0 0 1 .015-.479.34.34 0 0 1 .478.015l2.569 2.748a.334.334 0 0 1-.014.479M53.383 196.241a.343.343 0 0 1-.478-.014l-2.569-2.749a.34.34 0 0 1 .014-.479.343.343 0 0 1 .479.014l2.569 2.749a.34.34 0 0 1-.015.479M55.37 192.616a.343.343 0 0 1-.479-.014l-2.569-2.749a.34.34 0 0 1 .014-.479.343.343 0 0 1 .48.014l2.568 2.749a.334.334 0 0 1-.014.479"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A004D",
    d: "M83.914 179.17s2.085 2.019 2.242 2.132c1.924 1.451 4.199 2.408 6.592 2.702 3.29.407 6.645-.327 9.645-1.664 2.213-.99 4.417-2.204 6.094-3.986 4.266-4.526 3.218-12.573.403-17.573-2.175-3.863-6.18-6.663-10.692-5.024-11.308 4.114-41.094 21.308-41.094 21.308l6.492 11.247c-.004 0 20.304-9.138 20.318-9.142"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.251,
    d: "m83.914 179.169 16.048-6.564"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.26 0h209.48v200H22.26z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyMedicine);
export default __webpack_public_path__ + "static/media/buy-medicine.a46b5aec7dd0a1bc2a8b2440557c93be.svg";
export { ForwardRef as ReactComponent };